import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { Cog, FlaskConical, Wrench, Cpu, BookOpen, Building2 } from "lucide-react";
import Gallery from "../components/Gallery";

const GALLERY = [
  "https://images.pexels.com/photos/37561815/pexels-photo-37561815.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/7480243/pexels-photo-7480243.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.unsplash.com/photo-1738162837329-2f2a2cdebb5e?w=800&q=80",
  "https://images.unsplash.com/photo-1726220230389-cd363f6a52eb?w=800&q=80",
  "https://images.unsplash.com/photo-1726219836040-d9b7b8c0d46f?w=800&q=80",
  "https://images.unsplash.com/photo-1726219835852-5d2dcf6c216f?w=800&q=80",
];

const facilities = [
  { icon: Cog, title: "CNC & VMC Machine Shop", desc: "Industry-grade CNC turning centres, VMCs and conventional machines for hands-on precision training." },
  { icon: Wrench, title: "Tool Room", desc: "EDM, Wire Cut, surface grinders and jig-boring for tool, die and mould making." },
  { icon: Cpu, title: "Mechatronics & Automation Lab", desc: "PLCs, industrial robots, pneumatics, hydraulics and control panels replicating real factory floors." },
  { icon: FlaskConical, title: "Metrology & Quality Lab", desc: "3D CMM, profile projectors and precision measuring instruments for quality inspection." },
  { icon: BookOpen, title: "Library & Digital Classrooms", desc: "Reference library and smart classrooms with German-designed curriculum material." },
  { icon: Building2, title: "Campus Amenities", desc: "Gym, café, music room and recreation areas for all-round student well-being." },
];

export default function FacilitiesPage() {
  return (
    <div data-testid="facilities-page">
      <PageHero
        path="facilities.hero"
        kicker="Campus"
        title="Our Facilities"
        subtitle="State-of-the-art labs and workshops equipped to international standards, so every student trains on real, industry-grade machinery."
      />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {facilities.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl p-7 shadow-sm border border-slate-100 tilt-card">
              <div className="h-12 w-12 rounded-xl bg-yellow-400/15 flex items-center justify-center mb-4">
                <f.icon className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="text-lg font-bold text-[#0B2A6B] mb-1.5">{f.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-testid="facilities-gallery">
          <div className="text-center mb-8">
            <p className="kicker mb-3">Gallery</p>
            <h2 className="text-3xl font-bold text-[#0B2A6B]">Inside our workshops & labs</h2>
          </div>
          <Gallery images={GALLERY} testid="facilities-gallery-grid" />
        </div>

        <div className="max-w-3xl mx-auto px-4 text-center mt-14">
          <p className="text-slate-600">Want to see our campus in person?</p>
          <Link to="/contact" className="mt-4 inline-flex items-center gap-2 px-7 py-3.5 rounded-lg btn-primary" data-testid="facilities-visit-btn">
            Schedule a campus visit
          </Link>
        </div>
      </section>
    </div>
  );
}
